export default "__VITE_ASSET__DP89Vh00__"